<header class="sticky-top d-lg-block d-none">
  <div
    class="container-md d-flex flex-wrap align-items-center justify-content-center justify-content-md-between pt-3"
    [class.nav-top]="!hideSearch" [class.nav-top-no-search]="hideSearch">
    <nav class="navbar navbar-expand-lg navbar-light p-0" aria-label="primary navigation">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#headerNavbar"
        aria-controls="headerNavbar" aria-expanded="false" aria-label="Toggle navigation"
        (click)="isMenuCollapsed = !isMenuCollapsed">
        <span class="navbar-toggler-icon"></span>
      </button>
    </nav>
    <a [routerLink]="[homePath()]" (click)="onLogoClick()" class="col-4 col-md-2 text-dark text-decoration-none logo-home">
      <img src="/assets/img/memorabid-logo-white.svg" alt="Logo" />
    </a>
    <div class="col-md-1"></div>
    <div class="col-md-6 justify-content-center search--mobile" [class.hidden]="hideSearch || showBranded()">
      <div class="d-flex align-items-center justify-content-center px-2">
        <input #searchInputHeader id="searchInputHeader" [disabled]="showBranded() || hideSearch" type="search"
          [(ngModel)]="searchText" [placeholder]="'IDS_GLOBAL_SEARCH' | translate" aria-label="Search"
          (keydown.enter)="search()" (search)="searchText = searchInputHeader.value; search()" />
        <button id="searchButton" type="button" (click)="search()" title="Search" aria-label="Search">
          <fa-icon [icon]="faSearch"></fa-icon>
        </button>

        <a type="button" class="btn btn-gold d-md-none ml-2 uppercase" [routerLink]="[
            '/',
            languageService.userSelectedLanguage.code,
            'shop'
          ]">
          {{ "IDS_SHOP" | translate }}
        </a>
      </div>
    </div>
    <div class="col-md-3 text-end icon--desktop">
      @if(messageService.userDataCount.unpaidItems){
      <button type="button" class="iconButton button-with-badge" (click)="onIconPressed('account/cart')">
        <i class="pi pi-shopping-cart"></i>
        <span class="badge" [class.badge-two-digits]="
            messageService.userDataCount.unpaidItems > 9
          ">
          {{ messageService.userDataCount.unpaidItems }}
        </span>
      </button>
      } @if(authService.isAuthenticated()){
      <a type="button" class="iconButton" [routerLink]="[
          '/',
          languageService.userSelectedLanguage.code,
          'search-result-all'
        ]" [queryParams]="{ onlyFavorites: true, auctionStatus: -1 }">
        <fa-icon [icon]="faHeart" size="lg"></fa-icon>
      </a>
      }
      <button type="button" class="iconButton button-with-badge" (click)="onIconPressed('account/notifications')"
        title="Notifications" aria-label="Notifications">
        <fa-icon [icon]="faBell" size="lg"></fa-icon>
        @if(notificationService.unreadNotificationsCount > 0 &&
        notificationService.unreadNotificationsCount < 100){ <span class="badge" [class.badge-two-digits]="
            notificationService.unreadNotificationsCount > 9
          ">
          {{ notificationService.unreadNotificationsCount }}
          </span>
          } @else if(notificationService.unreadNotificationsCount >= 100){
          <span class="badge badge-three-digits">99+</span>
          }
      </button>
      <button type="button" class="iconButton button-with-badge" (click)="
          onIconPressed(
            authService.userLogged?.idProfile === 1
              ? 'admin/message/list'
              : 'account/messages'
          )
        " title="Messages" aria-label="Messages">
        <fa-icon [icon]="faEnvelope" size="lg"></fa-icon>
        @if(messageService.unreadMessagesCount > 0 && messageService.unreadMessagesCount < 100){ <span class="badge"
          [class.badge-two-digits]="messageService.unreadMessagesCount > 9">
          {{ messageService.unreadMessagesCount }}
          </span>
          } @else if(messageService.unreadMessagesCount >= 100){
          <span class="badge badge-three-digits">99+</span>
          }
      </button>
      <div ngbDropdown class="iconButton text-center" #accountDropdown="ngbDropdown">
        <button id="accountDropdown" type="button" class="iconButton" (click)="onAccountPressed('account')" ngbDropdownToggle
          title="Account" aria-label="Account">
          <fa-icon [icon]="faUser" size="lg"></fa-icon>
        </button>
        @if(authService.userLogged.idProfile !== 1){
        <div ngbDropdownMenu aria-labelledby="filterDropdown" class="accountDropdown">
          <p class="mb-0 text-nowrap accountNameDropdown">
            <i>{{ "IDS_HI" | translate
              }}{{ authService.userLogged.username }}</i>
          </p>
          <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="onIconPressed('account')">
            {{ "IDS_ACCOUNT" | translate }}
          </button>
          <button type="button" ngbDropdownItem class="accountDropdownLink"
            (click)="onIconPressed('account/my-auctions/awarded')">
            {{ "IDS_AUCTIONS" | translate }}
          </button>
          @if(isAutonomousSeller()) {
          <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="onIconPressed('admin-v2')">
            {{ "IDS_ADMIN" | translate }}
          </button>
          }
          @if(authService.isEventManager()) {
          <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="onIconPressed('admin-v2')">
            {{ "IDS_MANAGE_EVENT" | translate }}
          </button>
          }

          <hr />
          <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="logout()">
            {{ "IDS_LOGOUT" | translate }}
          </button>
        </div>
        } @else if(authService.userLogged.idProfile === 1){
        <div ngbDropdownMenu aria-labelledby="filterDropdown" class="accountDropdown">
          <p class="mb-0 text-nowrap accountNameDropdown">
            <i>{{ "IDS_HI" | translate
              }}{{ authService.userLogged.username }}</i>
          </p>
          <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="onIconPressed('account')">
            {{ "IDS_ADMIN" | translate }}
          </button>
          <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="onIconPressed('admin-v2')">
            {{ "IDS_ADMIN" | translate }} V2
          </button>
          <hr />
          <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="logout()">
            {{ "IDS_LOGOUT" | translate }}
          </button>
        </div>
        }
      </div>
    </div>
  </div>
  <nav class="navbar navbar-expand-lg navbar-light p-0" aria-label="main navigation">
    <div class="container-md p-2">
      <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse align-items-stretch" id="headerNavbar">
        @if(showBranded()) {
        <ul class="navbar-nav me-auto">
          <li class="nav-item one-line-item" routerLinkActive="active-link"
            *ngFor="let link of brandedLinks(); trackBy: trackByRoute" [class.active-link]="link.isActivated">
            @if(link.route.substring(1).split('/').length === 1) {
            <a class="nav-link text-uppercase" (click)="resetAuctionSource()" [routerLink]="['/',
                                        languageService.userSelectedLanguage.code,
                                        link.route.substring(1).split('/')[0],
                                        ]">{{ link.label | translate }}</a>
            } @else {<a class="nav-link text-uppercase" (click)="resetAuctionSource()" [routerLink]="['/',
                                                      languageService.userSelectedLanguage.code,
                                                      link.route.substring(1).split('/')[0],
                                                      link.route.substring(1).split('/')[1] || ''
                                                      ]">{{ link.label | translate }}</a>
            }

          </li>
          </ul>
        } @else {
        <ul class="navbar-nav me-auto">
          <li class="nav-item one-line-item" routerLinkActive="active-link" *ngFor="let link of links(); trackBy: trackByRoute"
            [class.active-link]="link.isActivated">
            <a class="nav-link text-uppercase" (click)="resetAuctionSource()"
              [routerLink]="['/', languageService.userSelectedLanguage.code, link.route.substring(1)]">{{ link.label |
              translate }}</a>
          </li>
        </ul>
        <ul class="navbar-nav ms-auto">
          <li class="item-right-navbar" routerLinkActive="active-link"
            *ngFor="let link of linksRight; trackBy: trackByRoute">
            <a class="nav-link text-uppercase {{ link.class }}" (click)="resetAuctionSource()"
              [routerLink]="['/', languageService.userSelectedLanguage.code, link.route.substring(1)]">{{ link.label |
              translate }}</a>
          </li>
        </ul>
        }
        <div ngbDropdown class="ms-1 align-self-center">
          <button id="languageDropdown" type="button" ngbDropdownToggle>
            <img class="flagImg" [src]="imgCountry" alt="flag" />
          </button>
          <div ngbDropdownMenu aria-labelledby="languageDropdown" class="dropdown-menu-lg-end">
            @for(lang of languageService.AppLanguageList; track lang.code) {
            <button (click)="changeLanguages(lang)" type="button" ngbDropdownItem
              class="lang-dropdown justify-content-center align-items-center d-flex">
              <p class="pt-3">{{ lang.description }}</p>
              &nbsp;&nbsp;
              <img class="flagImg" src="/assets/img/{{ lang.code }}.png" alt="flag" />
            </button>
            }
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>
